import { Stack, Divider, useTheme } from "@mui/material";
import { Button, FoodsIcon, Typography } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import type { TemplateCatalogCategory } from "./templateActionCatalog";

type Props = {
    categories: TemplateCatalogCategory[];
    onSelect: (categoryId: number) => void;
};

export const TemplateActionCategories = (props: Props) => {
    const { categories, onSelect } = props;

    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Stack divider={<Divider />}>
            {categories.map((item) => (
                <Stack
                    key={`${item.id}-template-catalog-category`}
                    direction={{ xs: "column", sm: "row" }}
                    alignItems={{ xs: "stretch", sm: "center" }}
                    justifyContent="space-between"
                    gap={theme.spacing(2)}
                    sx={{ py: theme.spacing(3) }}
                >
                    <Stack direction="row" alignItems="center" gap={theme.spacing(2)}>
                        <FoodsIcon icon={item.iconName ?? "actionPlan"} size={3} />
                        <Typography variant="body-bold">{item.title}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={theme.spacing(3)}>
                        <Typography component="p" variant="body-regular">
                            {t(
                                "settings.action_plan_templates.editor.engaged_actions",
                                "{{engaged}}/{{total}} engaged actions",
                                { engaged: item.engaged, total: item.total },
                            )}
                        </Typography>
                        <Button
                            variant="secondary"
                            aria-label={t("settings.action_plan_templates.editor.open_category", "Open {{name}}", {
                                name: item.title,
                            })}
                            onClick={() => onSelect(item.id)}
                        >
                            <FoodsIcon icon="arrowRight" size={2} />
                        </Button>
                    </Stack>
                </Stack>
            ))}
        </Stack>
    );
};
